import { Button as MuiButton, Badge } from "@mui/material";
import { styled, alpha, darken, lighten } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "childrenColor",
})<{ childrenColor?: "error" | "secondary" }>(
  ({ theme }) => ({
    width: "fit-content",
    display: "flex",
    gap: "10px",
    textTransform: "none",
    fontSize: "1em",
    padding: "0 5px",
    color: darken(theme.palette.text.secondary, 0.15),
    borderBottom: `1px solid ${lighten(theme.palette.text.secondary, 0.6)}`,
    borderRadius: 0,
    textDecoration: "none",
    transition: "all .3s ease",

    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  }),
  ({ childrenColor, theme }) => ({
    "& > span": {
      ...(childrenColor && { color: theme.palette[childrenColor].main }),
    },
  })
);

interface WidgetButtonProps {
  translationKey: string;
  handleClick?: () => void;
  children?: React.ReactNode;
  childrenColor?: "error" | "secondary";
  customWidgetButtonStyle?: React.CSSProperties;
  disabled?: boolean;
}

const WidgetButton = ({
  translationKey,
  handleClick,
  childrenColor,
  children,
  customWidgetButtonStyle,
  disabled,
}: WidgetButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={handleClick}
      childrenColor={childrenColor}
      style={{ ...customWidgetButtonStyle }}
    >
      {`${t(translationKey)}`}
      <Badge
        color={childrenColor}
        showZero
        badgeContent={children}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        title={"We have work to do!"}
        sx={{ marginLeft: "20px" }}
      />
    </Button>
  );
};

export default WidgetButton;
